'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var index = require('../wantlist/index.js');

var Ledger = /*#__PURE__*/function () {
  function Ledger(peerId) {
    _classCallCheck(this, Ledger);

    this.partner = peerId;
    this.wantlist = new index.Wantlist();
    this.exchangeCount = 0;
    this.sentToPeer = new Map();
    this.accounting = {
      bytesSent: 0,
      bytesRecv: 0
    };
  }

  _createClass(Ledger, [{
    key: "sentBytes",
    value: function sentBytes(n) {
      this.exchangeCount++;
      this.lastExchange = new Date().getTime();
      this.accounting.bytesSent += n;
    }
  }, {
    key: "receivedBytes",
    value: function receivedBytes(n) {
      this.exchangeCount++;
      this.lastExchange = new Date().getTime();
      this.accounting.bytesRecv += n;
    }
  }, {
    key: "wants",
    value: function wants(cid, priority, wantType) {
      this.wantlist.add(cid, priority, wantType);
    }
  }, {
    key: "cancelWant",
    value: function cancelWant(cid) {
      this.wantlist.remove(cid);
    }
  }, {
    key: "wantlistContains",
    value: function wantlistContains(cid) {
      return this.wantlist.get(cid);
    }
  }, {
    key: "debtRatio",
    value: function debtRatio() {
      return this.accounting.bytesSent / (this.accounting.bytesRecv + 1);
    }
  }]);

  return Ledger;
}();

exports.Ledger = Ledger;